import axios from 'src/utils/axios';


export const getExternalSystemDatas = (
    payload
) => {
    return axios.post('/GetExternalSystemTasks', payload);
}

export const getWorkOrderUrgentCustomers = (payload) => {
    return axios.post('/GetWorkOrderUrgentCustomers', payload);
};